//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    position: {
      type: String,
      default: ''
    }
  },
  computed: {
    isEn () {
      return this.$i18n.locale === 'en'
    }
  }
}
